import { render } from "./SuperUserManagement.vue?vue&type=template&id=02e04562&ts=true"
import script from "./SuperUserManagement.vue?vue&type=script&lang=ts"
export * from "./SuperUserManagement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__